export interface MagicProperty {
  // user-friendly name
  name: string;
  // full path to property i.e. "UserActivityData.UserSummary.LastActiveDate"
  replacementKey: string;
  // nested properties
  children?: MagicProperty[];
  level?: number;
}

export interface UpdateMagicPropertyEvent {
  value: string;
  valid: boolean;
}

export class MagicPropertyBuilder {
  public static stringListToModels(list: string[]) {
    const magicNestedProperties: MagicProperty[] = [];
    if (list?.length) {
      for (const item of list) {
        magicNestedProperties.push({
          name: item,
          replacementKey: this.formatMagicVariable(item)
        });
      }
    }
    return magicNestedProperties;
  }

  public static formatMagicVariable(magicVariable: string) {
    if (!magicVariable.startsWith('{{')) magicVariable = `{{${magicVariable}`;
    if (!magicVariable.endsWith('}}')) magicVariable = `${magicVariable}}}`;
    return magicVariable;
  }

  public static createNestedArrayFromKeys(list: string[], level: number = 0): MagicProperty[] {
    if (!list?.length) return null;

    const result: MagicProperty[] = [];

    const processKey = (key: string, currentLevel: MagicProperty[], level: number): void => {
      const parts = key.split('.');
      let existingNode = currentLevel.find(node => node.name === parts[level]);

      if (!existingNode) {
        // If we’re at the last part, assign the full replacementKey
        const newNode: MagicProperty = {
          name: parts[level],
          replacementKey: parts.slice(0, level + 1).join('.'),
          children: [],
          level
        };
        currentLevel.push(newNode);
        existingNode = newNode;
      }

      // If there are more parts to process, go deeper recursively
      if (level + 1 < parts.length) {
        processKey(key, existingNode.children, level + 1);
      }
    };

    list.forEach(key => {
      processKey(key, result, level);
    });

    return result;
  }
}